var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.1,
    height: 24.565,
    viewBox: "0 0 24.1 24.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(2.184 3.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M518.868,505.082v13.825c0,.6,0,1.206,0,1.806a2.049,2.049,0,0,1-.02.294c.017-.129.035-.262.052-.391a2.151,2.151,0,0,1-.135.494c.05-.117.1-.235.147-.35a2.156,2.156,0,0,1-.27.465c.076-.1.153-.2.229-.3a2.244,2.244,0,0,1-.35.353l.3-.23a2.171,2.171,0,0,1-.465.274l.35-.147a2.151,2.151,0,0,1-.494.135l.391-.053a4.528,4.528,0,0,1-.57.021H507.089c-.495,0-.989,0-1.483,0a1.9,1.9,0,0,1-.291-.021l.391.053a2.2,2.2,0,0,1-.5-.135c.117.05.235.1.35.147a2.071,2.071,0,0,1-.468-.274l.3.23a2.161,2.161,0,0,1-.356-.353l.23.3a2.259,2.259,0,0,1-.277-.465c.05.118.1.235.147.35a2.158,2.158,0,0,1-.138-.494c.018.129.035.262.053.391a4.607,4.607,0,0,1-.021-.644V507.036c0-.644.012-1.289,0-1.93v-.026l-1.471,1.471h14.71c.677,0,1.356.008,2.033,0h.029a1.532,1.532,0,0,0,1.042-.43,1.479,1.479,0,0,0,0-2.083,1.527,1.527,0,0,0-1.042-.429H505.618c-.677,0-1.357-.009-2.033,0h-.03a1.493,1.493,0,0,0-1.471,1.471v15.577a3.507,3.507,0,0,0,3.51,3.566h11.627c.376,0,.756.009,1.132,0a3.507,3.507,0,0,0,3.007-1.8,3.728,3.728,0,0,0,.438-1.774V505.077a1.531,1.531,0,0,0-.429-1.042,1.479,1.479,0,0,0-2.083,0A1.608,1.608,0,0,0,518.868,505.082Z",
    transform: "translate(-502.084 -503.605)",
    fill: "#e21313"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(6.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M514.673,503.164v1.916l1.471-1.471h-8.385l1.471,1.471v-1.063a8.683,8.683,0,0,1,.021-1.141c-.018.129-.035.262-.053.391a2.217,2.217,0,0,1,.135-.494c-.05.118-.1.235-.147.35a2.052,2.052,0,0,1,.274-.465l-.23.3a2.144,2.144,0,0,1,.353-.353l-.3.23a2.244,2.244,0,0,1,.465-.274c-.118.05-.235.1-.35.147a2.272,2.272,0,0,1,.494-.135l-.391.053a5.281,5.281,0,0,1,.641-.021h3.51a5.86,5.86,0,0,1,.75.021l-.391-.053a2.256,2.256,0,0,1,.494.135c-.118-.05-.235-.1-.35-.147a2.052,2.052,0,0,1,.465.274l-.3-.23a2.144,2.144,0,0,1,.353.353l-.23-.3a2.248,2.248,0,0,1,.274.465c-.05-.118-.1-.235-.147-.35a2.165,2.165,0,0,1,.135.494c-.018-.129-.035-.262-.053-.391.009.1.015.194.015.288a1.536,1.536,0,0,0,.429,1.042,1.479,1.479,0,0,0,2.083,0,1.514,1.514,0,0,0,.43-1.042,3.492,3.492,0,0,0-1.168-2.6,3.635,3.635,0,0,0-1.421-.777,3.893,3.893,0,0,0-.936-.121c-.67,0-1.338,0-2.009,0h-2.209a3.657,3.657,0,0,0-1.857.477,3.465,3.465,0,0,0-1.647,2.265,8.48,8.48,0,0,0-.086,1.568v1.1a1.493,1.493,0,0,0,1.471,1.471h8.385a1.493,1.493,0,0,0,1.471-1.471v-1.916a1.532,1.532,0,0,0-.43-1.041,1.475,1.475,0,0,0-2.082,0A1.58,1.58,0,0,0,514.673,503.164Z",
    transform: "translate(-506.282 -499.662)",
    fill: "#e21313"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0 3.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M522.528,503.611h-20.3c-.273,0-.55,0-.823,0h-.036a1.531,1.531,0,0,0-1.041.43,1.476,1.476,0,0,0,0,2.083,1.523,1.523,0,0,0,1.041.429h20.3c.273,0,.55,0,.824,0h.035a1.528,1.528,0,0,0,1.041-.429,1.476,1.476,0,0,0,0-2.083,1.543,1.543,0,0,0-1.041-.43Z",
    transform: "translate(-499.9 -503.61)",
    fill: "#e21313"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(7.739 9.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M507.639,510.381v7.075a1.531,1.531,0,0,0,.429,1.042,1.479,1.479,0,0,0,2.083,0,1.528,1.528,0,0,0,.43-1.042v-7.075a1.532,1.532,0,0,0-.43-1.042,1.479,1.479,0,0,0-2.083,0,1.541,1.541,0,0,0-.429,1.042Z",
    transform: "translate(-507.639 -508.909)",
    fill: "#e21313"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(13.493 9.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M513.393,510.381v7.075a1.532,1.532,0,0,0,.43,1.042,1.483,1.483,0,0,0,1.041.429,1.5,1.5,0,0,0,1.042-.429,1.532,1.532,0,0,0,.429-1.042v-7.075a1.536,1.536,0,0,0-.429-1.042,1.479,1.479,0,0,0-2.083,0,1.528,1.528,0,0,0-.43,1.042Z",
    transform: "translate(-513.393 -508.909)",
    fill: "#e21313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.fd9d77249329902298db3ef6a89c17bc.svg";
export { ForwardRef as ReactComponent };